/**
 * VRSI — IFR do Volume (Índice de Força Relativa do Volume).
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLVolume.cs, classe
 * FML.VRSI — fórmula idêntica no TradeZonePlatform):
 *
 *   VRSI = SMA(MAX(VOL - REF(VOL,1), 0), N, 1)
 *        / SMA(ABS(VOL - REF(VOL,1)), N, 1) * 100
 *
 * SMA(x,N,1) é a "SMA chinesa" (Wilder com seed de média simples) — ver
 * silverlightDsl.js. Paridade numérica provada contra o engine original em
 * __tests__/vrsi.silverlight.test.js (oráculo: tools/silverlight-oracle).
 */
import { ref, sub, max2, abs, sma, div, mul } from "./silverlightDsl";
import { VRSI as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    // d.volume pode já ter sido processado pelo indicador Volume no mesmo
    // pipeline (applyIndicators roda em ordem): vira { volume, direction }.
    // Desembrulha para o número cru em qualquer ordem de processamento.
    const vol = data.map((d) => {
      const raw = d.volume;
      const v =
        raw !== null && typeof raw === "object"
          ? Number(raw.volume)
          : Number(raw);
      return Number.isFinite(v) ? v : NaN;
    });
    const diff = sub(vol, ref(vol, 1));
    const up = sma(max2(diff, 0), period, 1);
    const dn = sma(abs(diff), period, 1);
    const vrsi = mul(div(up, dn), 100);

    // Borda com o chart: NaN/±Inf (warm-up, volume ausente, divisão por zero)
    // viram undefined — mesmo contrato dos demais calculators.
    return vrsi.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return period;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
